import React from 'react';
export const ListWrapper = (props) => {
    var _a;
    const ListTag = (_a = props.listType) !== null && _a !== void 0 ? _a : 'ol';
    return (React.createElement(ListTag, { className: props.className }, React.Children.map(props.children, (elem) => (React.createElement("li", { className: props.elementClassName }, elem)))));
};
